function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M32.37 6.725l-3.468-3.524c-1.302-1.3-3.411-1.3-4.713 0L6.992 20.331c-.363.37-.637.82-.8 1.312l-3.88 11.616 11.628-3.88c.487-.167.93-.44 1.3-.8l17.13-17.14c1.3-1.303 1.3-3.412 0-4.714zM9.026 21.487l9.727-9.715 1.756 1.756-9.76 9.727-1.723-1.768zm11.25-11.294l1.767-1.756 5.091 5.091-1.756 1.768-5.102-5.103zM7.892 23.555l4.136 4.124-6.192 2.056 2.056-6.18zm6.192 3.035l-1.767-1.768 9.726-9.715 1.757 1.756-9.716 9.727zM30.758 9.916l-2.09 2.09-5.057-5.147 2.09-2.09c.21-.208.493-.324.789-.323.295-.001.58.115.789.323l3.524 3.535c.205.207.32.486.322.778.002.295-.114.58-.322.79l-.045.044z",
  transform: "translate(-475 -2699) translate(475.143 2699.714)"
}))));

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.6d0b6232.svg";
export { ForwardRef as ReactComponent };